import { fetch } from '@/shared/fetch';

export const fetchWithTimeout = async <T>(
    url: string,
    method: string,
    data: any,
    timeoutMs: number,
    contentType?: string | 'AUTOMATIC',
): Promise<T> => {
    const controller = new AbortController();

    const timeoutId = setTimeout(() => {
        controller.abort();
    }, timeoutMs);

    try {
        return await fetch<T>(
            url,
            method,
            data,
            contentType,
            controller.signal,
        );
    } finally {
        clearTimeout(timeoutId);
    }
};
